import * as React from 'react';
const NumberedNotification = (props) => (React.createElement("div", { className: "NumberedNotification" }, props.notifications));
export default NumberedNotification;
